module.exports = "<app-widgets-sortable-panel ng-init=\"relation = $ctrl.relation\" class=relation id=\"{{ ::$ctrl.relationType }}-{{$ctrl.index}}\" index=$ctrl.index object=$ctrl.relation first=$ctrl.first last=$ctrl.last read-only=$ctrl.readOnly> <spanel-title> <span>{{ ::$ctrl.relationTypeName }}</span> {{ $ctrl.index + 1 }}: <span class=relation-title>{{ relation.name | appTranslateField: $ctrl.route.main_lang }}</span> </spanel-title> <spanel-body><ng-transclude></ng-transclude></spanel-body> </app-widgets-sortable-panel> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/relation/partial.html
// module id = 492
// module chunks = 0